"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _Radio = _interopRequireDefault(require("../../Radio"));

var _FormikValidation = _interopRequireDefault(require("../FormikValidation"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FormikRadioGroup = function FormikRadioGroup(props) {
  return _react.default.createElement("div", null, props.children, _react.default.createElement(_FormikValidation.default, {
    name: props.name
  }));
};

FormikRadioGroup.propTypes = {
  name: _propTypes.string.isRequired,
  children: (0, _propTypes.arrayOf)(_Radio.default).isRequired
};
var _default = FormikRadioGroup;
exports.default = _default;